<template>
  <div>
    <div v-if="saving" class="overlay"></div>
    <layout menu-item="8">
      <div class="cont">
        <h2>Live Server Update</h2>
        <button class="btn btn-danger" @click="save()">Daten</button>
        <button class="btn btn-danger" @click="save('apps')">Daten + Apps</button>
        <br>
        <br>
        <div v-if="message" style="background-color: lightgrey; width:100%;padding:1rem;">
         <pre v-html="message"></pre>
        </div>
      </div>

    </layout>
  </div>
</template>

<script>
  import Backend from '@/Backend';

  export default {
    name: "Update",
    data() {
      return {
        saving: false,
        message: null
      }
    },
    methods: {
      save(mode) {
        const a = confirm('Updaten?');
        if (a) {
          this.saving = true;
          this.message = null;
          Backend.instance.export(mode)
            .then((response) => {
              this.saving = false;
              this.message = response.message;
            })
            .catch((e) => {

            });
        }
      }
    }
  }
</script>

<style scoped>
  .cont {
    padding: 2rem;
  }

  .overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.6);
  }

  pre {
    font-size: 0.9rem;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/update/Update.vue